import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { HttpClient } from '@angular/common/http';
import { CreatorTeamResponse } from '../models/creator-team-response';
import { catchError, shareReplay } from 'rxjs/operators';
import { CreatorTeamMediaResponse } from '../models/creator-team-media-response';

@Injectable({
  providedIn: 'root'
})
export class CreatorTeamService {

  private cachedFollows$: BehaviorSubject<number[]> = new BehaviorSubject(null);
  private myFollows$: Observable<number[]>;

  constructor(
    private envService: EnvironmentService,
    private http: HttpClient) {
  }

  getTeams(): Observable<CreatorTeamResponse[]> {
    return this.http.get<CreatorTeamResponse[]>(`${this.envService.contentHost}/v2/creatorteam`)
  }

  getMyFollows(): Observable<number[]> {

    if (this.myFollows$ === undefined) {
      this.myFollows$ = this.http.get<number[]>(`${this.envService.contentHost}/v2/creatorteam/my-follows`).pipe(shareReplay(1));
    }

    this.myFollows$.subscribe(x => this.cachedFollows$.next(x));

    return this.cachedFollows$.asObservable();
  }

  followTeam(teamId: number): Observable<any> {
    const currentArray = this.cachedFollows$.value;
    let arrayUpdated = false;
    if (!currentArray.includes(teamId)) {
      const updatedArray = [...currentArray, teamId];
      this.cachedFollows$.next(updatedArray);
      arrayUpdated = true;
    }
    return this.http.post<any>(`${this.envService.contentHost}/v2/creatorteam/${teamId}/follow`, {})
      .pipe(catchError(x => {
        if (arrayUpdated) {
          this.cachedFollows$.next(currentArray);
        }
        throw x
      }));
  }

  unfollowTeam(teamId: number): Observable<any> {
    const currentArray = this.cachedFollows$.value;
    const updatedArray = currentArray.filter(number => number !== teamId);
    const arrayUpdated = currentArray.length !== updatedArray.length;
    if (arrayUpdated) {
      this.cachedFollows$.next(updatedArray);
    }


    return this.http.post<any>(`${this.envService.contentHost}/v2/creatorteam/${teamId}/unfollow`, {})
      .pipe(catchError(x => {
        if (arrayUpdated) {
          this.cachedFollows$.next(currentArray);
        }
        throw x
      }));
  }

  getTeam(teamId: number): Observable<CreatorTeamResponse> {
    return this.http.get<CreatorTeamResponse>(`${this.envService.contentHost}/v2/creatorteam/${teamId}`)
  }

  getTeamBySlug(slug: string): Observable<CreatorTeamResponse> {
    if (+slug) {
      return this.http.get<CreatorTeamResponse>(`${this.envService.contentHost}/v2/creatorteam/${slug}`)
    } else {
      return this.http.get<CreatorTeamResponse>(`${this.envService.contentHost}/v2/creatorteam/slug/${slug}`)
    }
  }

  getTeamVideos(teamId: number, tab: string, filter: string = '', page: number = 1): Observable<CreatorTeamMediaResponse> {
    let url = `${this.envService.contentHost}/v2/creatorteam/${teamId}/media/${tab}?page=${page}`;
    if (filter !== '') {
      url += `&year=${filter}`;
    }
    return this.http.get<CreatorTeamMediaResponse>(url);
  }
}
